import React, { useState } from 'react';
import { Copy, Check } from 'lucide-react';
import { formatPersianDate } from 'utils/formatPersianDate';
import { formatPersianNumber } from 'utils/formatPersianNumber';

const TransactionDetails = ({
  referenceCode,
  followupCode,
  amount,
  dateTime,
}) => {
  const [copied, setCopied] = useState(false);
  const [copyMessage, setCopyMessage] = useState('');

  const handleCopy = async (text) => {
    try {
      await navigator.clipboard.writeText(text);
      setCopied(true);
      setCopyMessage('  کپی شد');
      setTimeout(() => {
        setCopied(false);
        setCopyMessage('');
      }, 1500);
    } catch {
      setCopyMessage('  کپی به مشکل خورد');
      setTimeout(() => setCopyMessage(''), 1500);
    }
  };

  return (
    <div className="bg-white rounded-2xl shadow-xl p-6 md:p-8 space-y-3 md:space-y-4">
      <div className="flex justify-between items-center pb-3 md:pb-4 border-b border-purple-100">
        {' '}
        <span className="text-sm md:text-base text-gray-500">
          شماره تراکنش
        </span>{' '}
        <span
          className="text-sm md:text-base lg:text-lg font-medium text-gray-800"
          dir="ltr"
        >
          {formatPersianNumber(referenceCode) || '---'}
        </span>
      </div>

      <div className="flex justify-between items-center pb-3 md:pb-4 border-b border-purple-100">
        <span className="text-sm md:text-base text-gray-500">کد پیگیری</span>
        <span
          className="text-sm md:text-base lg:text-lg font-medium text-gray-800 flex items-center gap-2"
          dir="ltr"
        >
          {followupCode}
          <button
            onClick={() => handleCopy(`${followupCode}`)}
            className="inline-flex items-center justify-center p-0.5 rounded hover:bg-purple-50 transition-colors"
            title="کپی کد پیگیری"
          >
            {copied ? (
              <Check className="w-4 h-4 text-green-500" />
            ) : (
              <Copy className="w-4 h-4 text-gray-400 hover:text-purple-600 transition-colors" />
            )}
          </button>
          {copyMessage && <span className="text-xs text-green-600 font-normal">{copyMessage}</span>}
        </span>
      </div>

      <div className="flex justify-between items-center pb-3 md:pb-4 border-b border-purple-100">
        <span className="text-sm md:text-base text-gray-500">مبلغ پرداختی</span>
        <span className="text-base md:text-lg lg:text-xl font-bold text-purple-600">
          {formatPersianNumber(amount)} تومان
        </span>
      </div>

      <div className="flex justify-between items-center">
        <span className="text-sm md:text-base text-gray-500">
          تاریخ و زمان پرداخت
        </span>
        <span className="text-sm md:text-base text-gray-800" dir="rtl">
          {formatPersianDate(dateTime)}
        </span>
      </div>
    </div>
  );
};

export default TransactionDetails;
